// export const capitalize = string =>
//   string ? string.replace(/\b\w/g, l => l.toUpperCase()) : ''

import { round } from 'lodash'

// const removeSpecialCharacters = word => word.replace(/[^\w\s]/gi, '')

// const capitalizeOnlyLetters = str =>
//   str
//     .toLowerCase()
//     .replace(/\w{3,}/g, match => match.replace(/\w/, m => m.toUpperCase()))

export const capitalize = (str = '') => {
  if (str === null) return ''
  if (typeof str !== 'string') return str
  if (str && str !== str.toLowerCase()) return str
  const smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|v.?|vs.?|via)$/i
  const alphanumericPattern = /([A-Za-z0-9\u00C0-\u00FF])/
  const wordSeparators = /([ :â€"â€"-])/
  return str
    .split(wordSeparators)
    .map(function(current, index, array) {
      if (
        /* Check for small words */
        current.search(smallWords) > -1 &&
        /* Skip first and last word */
        index !== 0 &&
        index !== array.length - 1 &&
        /* Ignore title end and subtitle start */
        array[index - 3] !== ':' &&
        array[index + 1] !== ':' &&
        /* Ignore small words that start a hyphenated phrase */
        (array[index + 1] !== '-' ||
          (array[index - 1] === '-' && array[index + 1] === '-'))
      ) {
        return current.toLowerCase()
      }
      // /* Ignore intentional capitalization */
      // if (current.substr(1).search(/[A-Z]|\../) > -1) {
      //   return current
      // }
      // /* Ignore URLs */
      // if (array[index + 1] === ':' && array[index + 2] !== '') {
      //   return current
      // }
      /* Capitalize the first letter */
      return current.replace(alphanumericPattern, function(match) {
        return match.toUpperCase()
      })
    })
    .join('')
}

export const spacesToUnderscores = (string) => string.replace(/ /g, '_')

export const yearRanges = years => {
  if (years < 2) return round(years, 0)
  let start_year = round(years * 0.5, 0)
  let end_year =
    round(years * 0.7, 0) === start_year
      ? start_year + 1
      : round(years * 0.7, 0)
  return `${start_year} - ${end_year}`
}

export const getRootFromInsToken = (insToken = '') => {
  const trimmedInsToken = insToken.substring(2)
  const regex = RegExp('s[0-9]+.*$')
  const n = trimmedInsToken.indexOf(regex.exec(trimmedInsToken))

  return trimmedInsToken.substring(0, n !== -1 ? n : trimmedInsToken.length)
}

const rangeModifications = [
  { drop: 0.15, max: 50000, min: 25000, raise: 0.15 },
  { drop: 0.15, max: 70000, min: 50000, raise: 0.15 },
  { drop: 0.17, max: 100000, min: 70000, raise: 0.17 },
  { drop: 0.2, max: 150000, min: 100000, raise: 0.2 },
  { drop: 0.22, max: 200000, min: 150000, raise: 0.22 },
]
export const salaryRange = salary => {
  let displaySalary = ''

  if (typeof salary !== 'number' || salary < 1) return displaySalary
  if (salary < 30000) return '<$30k'
  if (salary >= 200000) return '$200k+'
  rangeModifications.forEach(r => {
    if (r.min <= salary <= r.max) {
      displaySalary = `$${round((salary * (1 - r.drop)) / 1000)}k - $${round(
        (salary * (1 + r.raise)) / 1000,
      )}k`
    }
  })
  return displaySalary
}



// WEBPACK FOOTER //
// ./src/utils/string/index.js